import { render, staticRenderFns } from "./createapp.vue?vue&type=template&id=337f1db0&scoped=true&"
import script from "./createapp.vue?vue&type=script&lang=js&"
export * from "./createapp.vue?vue&type=script&lang=js&"
import style0 from "./createapp.vue?vue&type=style&index=0&id=337f1db0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337f1db0",
  null
  
)

export default component.exports